/**
 * Organization owners cannot manage their own portal user via MMS; Skipify admins may still
 * update their own record where the API allows it.
 */
export function shouldBlockPortalUserSelfManagement(
  targetUserId: string,
  currentUserId: string | null | undefined,
  isSkipifyAdmin: boolean,
): boolean {
  if (!currentUserId || targetUserId !== currentUserId) {
    return false;
  }
  return !isSkipifyAdmin;
}
